@if (products$ | withLoading | async; as result) {
  @if (result.value; as products) {
    <div [class]="styleClass()">
      <div class="grid grid-cols-1 gap-8 lg:grid-cols-3">
        @for (product of products; track product.id) {
          <div
            [class.bg-white]="isPaymentPeriodOnce(product)"
            [class.bg-black]="isPaymentPeriodMonthly(product)"
            [class.text-white]="isPaymentPeriodMonthly(product)"
            [class.bg-gray-50]="isPaymentPeriodPerMonth(product)"
            class="border border-gray-200 bg-white p-6 transition-transform hover:scale-105 hover:shadow-2xl">
            <div class="text-2xl font-light uppercase">
              {{ product.headline }}
            </div>

            <div class="font-black uppercase">{{ product.name }}</div>

            <div class="mt-3 inline-flex items-end gap-1">
              <div class="text-5xl font-black">{{ product.price }} zł</div>
              <div class="inline-flex gap-1 text-lg">
                <span>/</span>
                <span>{{
                  product.paymentPeriod
                    | publicProductCompositePaymentPeriodLabel
                    | async
                }}</span>
              </div>
            </div>

            <div class="mt-6 justify-center">
              <app-public-cart-add-button
                label="Kup"
                [theme]="themeTypeByPaymentPeriod(product)"
                [sales]="product.sales" />
            </div>

            <div class="mt-6 leading-loose">
              <div
                class="list"
                [innerHTML]="product.description | safeHtml"></div>
            </div>
          </div>
        }
      </div>
    </div>
  } @else {
    <div class="py-4">
      <app-spinner-filled />
    </div>
  }
}
